import React from "react";
import CustomMenu from "./CustomMenu";
import CustomBar from "./CustomBar";
import {Layout} from "react-admin";

const CustomLayout = props => <Layout {...props} menu={CustomMenu} appBar={CustomBar}/>;

export default CustomLayout;
